import Iconify from "@/components/ui/Iconify";
import { useDropzone } from "react-dropzone";
import SingleFilePreview from "./single-file-preview";
import RejectionFiles from "./rejection-files";
import { useTranslations } from "@/lib/static-intl";

const Upload = ({
  disabled,
  multiple = false,
  error,
  helperText,
  file,
  onDelete,
  files,
  thumbnail,
  onUpload,
  onRemove,
  onRemoveAll,
  isImageUploader,
  className,
  ...other
}) => {
  const t = useTranslations("creator_service.create_note_media_upload");

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
    fileRejections,
  } = useDropzone({
    multiple,
    disabled,
    ...other,
  });

  const hasFile = !!file && !multiple;
  const hasError = isDragReject || !!error;

  const renderPlaceholder = (
    <div className="flex flex-col items-center justify-center gap-2">
      <Iconify icon="ion:cloud-upload" className="!w-6 !h-6" />
      {isImageUploader ? (
        <>
          <span className="text-sm text-center">{t("drag_btn_img_label")}</span>
          <span className="text-xs text-center text-gray-500 -mt-2 mb-2">
            ({t("drag_btn_img_label_limit")})
          </span>
        </>
      ) : (
        <span className="text-sm text-center">{t("drag_btn_vid_label")}</span>
      )}
      <button className="bg-red text-white py-2 px-4 text-sm font-bold rounded-full">
        {isImageUploader ? t("Upload Image") : t("Upload Video")}
      </button>
    </div>
  );

  const renderSinglePreview = (
    <SingleFilePreview
      imgUrl={typeof file === "string" ? file : file?.preview}
    />
  );

  return (
    <div className={`relative mb-2 w-full ${className}`}>
      <div
        {...getRootProps()}
        className={`p-10 flex justify-center items-center cursor-pointer overflow-hidden relative dark:bg-brown bg-gray-100 border border-dashed hover:border-red transition-opacity rounded-lg ${isDragActive ? "opacity-70" : ""
          } ${disabled ? "opacity-50 pointer-events-none" : ""} ${hasError ? "text-red-600 border-red-600 bg-red-50" : ""
          } ${hasFile ? "py-24" : ""} ${className}`}
      >
        <input {...getInputProps()} />
        {hasFile ? renderSinglePreview : renderPlaceholder}
      </div>
      {helperText && (
        <span className="text-sm text-gray-500 mt-2">{helperText}</span>
      )}
      <RejectionFiles fileRejections={fileRejections} />
    </div>
  );
};

export default Upload;
